export const GET_HELPER_DATA = 'GET_HELPER_DATA';
export const setHelperData = (data: any) => ({
    type: GET_HELPER_DATA,
    payload: data,
});
